const m2 = ( x, y ) => +( +x * +y ).toFixed( 3 );
export default m2;